import React, { useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import BlockContent from "../../block-content";
import { motion, AnimateSharedLayout, AnimatePresence } from "framer-motion";
import "../../Faq/Faq.scss";

const SpecialCaseForeignObject = () => {
  const data = useStaticQuery(graphql`
  query foreignObjectQuery {
    foreignObject: sanityForeignObject {
      id
      _rawForeignObjectFaqItems
      _rawBody
      title
    }
  }
`);

const foreignObjectData = (data || {}).foreignObject;

  return (
    <>
      <h1>{foreignObjectData.title}</h1>
      <BlockContent blocks={foreignObjectData._rawBody || []} />

      {foreignObjectData._rawForeignObjectFaqItems !== null && (
        <div className="faq__wrapper">
          <AnimateSharedLayout>
            <motion.ul className="faq__ul" layout initial={{ borderRadius: 25 }}>
              {foreignObjectData._rawForeignObjectFaqItems.map(foreignObjectFaqItem => (
                <Item
                  key={foreignObjectFaqItem._key}
                  headline={foreignObjectFaqItem.question}
                  data={foreignObjectFaqItem.answer}
                />
              ))}
            </motion.ul>
          </AnimateSharedLayout>
        </div>
      )}

    </>
  )
}

export default SpecialCaseForeignObject

const Item = ({ headline, data }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <>
      <motion.li layout onClick={toggleOpen} initial={{ borderRadius: 10 }}>
        <motion.div className="faq__headerGrid" layout>
          <div className="faq__avatar"></div>
          <h2>{headline}</h2>
        </motion.div>
        <AnimatePresence>{isOpen && <Content data={data} />}</AnimatePresence>
      </motion.li>
    </>
  );
};

const Content = ({ data }) => {
  return (
    <motion.div layout initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <BlockContent blocks={data || []} />
    </motion.div>
  );
};